/* ==========================================================================
   Jellice — Cart Drawer Routine cross-sell AJAX add-to-cart

   Why this exists:
   - The routine cards live inside the cart drawer, which renders on every
     page (including the homepage).
   - Dawn's <product-form> custom element is only registered when
     product-form.js is loaded — and that script is included by product
     detail templates, NOT site-wide. So <product-form> is unreliable.
   - This script binds a single event delegated handler at the document
     level. It survives cart-drawer re-renders and works on every page.

   Flow:
   1. User clicks "+ Add" inside .jellice-routine-add-form
   2. We POST to /cart/add.js with:
        id, quantity, sections=cart-drawer,cart-icon-bubble, sections_url
   3. On success, call cart-drawer.renderContents(response) which Dawn
      ships with — it swaps the inner HTML of the drawer with the updated
      sections returned by Shopify.
   4. The added product disappears from the routine list (because the
      snippet filters out products already in cart) and appears in the
      cart items list above. Header cart icon bubble also updates.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__jelliceRoutineWired) return;
  window.__jelliceRoutineWired = true;

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest
      ? event.target.closest('.jellice-routine-add-form')
      : null;
    if (!form) return;
    event.preventDefault();
    handleAdd(form);
  });

  function handleAdd(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    btn.disabled = true;
    var originalLabel = btn.textContent;
    btn.dataset.originalLabel = originalLabel;
    btn.textContent = 'Adding…';

    var cartDrawer = document.querySelector('cart-drawer');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (addUrl.indexOf('.js') === -1) addUrl = addUrl + '.js';

    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];

    var body = new FormData(form);
    body.append('sections', sectionIds.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data && data.status) {
          // Shopify returned an error (e.g., out of stock). Show description.
          console.warn('[jellice-routine] add error:', data);
          showInlineError(form, data.description || 'Could not add to cart');
          return;
        }
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        } else {
          // No drawer — just reload so user sees updated cart.
          window.location.reload();
        }
      })
      .catch(function (err) {
        console.warn('[jellice-routine] add failed:', err);
        // Fallback: full page redirect to cart so user isn't stuck
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .finally(function () {
        // Restore button state. (Drawer may have re-rendered — guard.)
        if (form.isConnected && btn.isConnected) {
          btn.classList.remove('is-loading');
          btn.disabled = false;
          if (btn.dataset.originalLabel) btn.textContent = btn.dataset.originalLabel;
        }
      });
  }

  function showInlineError(form, message) {
    var card = form.closest('.jellice-cart__routine-card');
    if (!card) return;
    var existing = card.querySelector('.jellice-cart__routine-err');
    if (existing) existing.remove();
    var err = document.createElement('p');
    err.className = 'jellice-cart__routine-err';
    err.textContent = message;
    card.appendChild(err);
    setTimeout(function () { if (err.isConnected) err.remove(); }, 4000);
  }
})();
